const MessageContact = ({message}) => {
    try {
        const jsonObject = typeof message.text === 'string' ? JSON.parse(message.text) : message.text;
        const {contacts} = jsonObject;
        let i = 0;
        return contacts.map(({name, phone, phones}) => {
            i++;
            const phonesString = phones?phones.map(item=>item.phone).join(","):phone;
            return <div key={`${name}${i}`} className="message-contact message-text">
                {name.formatted_name} - {phonesString}
            </div>
        })
    } catch (err) {
        console.log(err)
        return <div className="message-text">{message.text}</div>
    }
}

export default MessageContact;